/**
 * Apply on a single element or an array of elements
 *
 * Callback will be invoked when clicks happen outside of those elements
 *
 * Clicks are registered at mousedown at capture phase because it is mostly used to hide popups
 * so they can be hidden before something else appears when a click finishes
 *
 * Returns a function to remove click listener
 */
export function clickOutside(element, cb, doc) {
    if (doc === void 0) { doc = document; }
    var elements = Array.isArray(element) ? element : [element];
    function listener(event) {
        var path = event.composedPath();
        if (!elements.some(function (el) { return path.includes(el); })) {
            cb(event);
        }
    }
    doc.addEventListener('mousedown', listener, true);
    return function () {
        doc.removeEventListener('mousedown', listener, true);
    };
}
